import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'player-skip-forward', 'IconPlayerSkipForward', [["path",{"d":"M4 5v14l12 -7z","key":"svg-0"}],["path",{"d":"M20 5l0 14","key":"svg-1"}]]);